module.exports = __webpack_public_path__ + "img/ideaone.44151030.png";